import CompanyPricesApi from './Api'

// only override all for AdminTable compatability
export default class TransferPricingApi extends CompanyPricesApi {
  all() {
    return super.getTransferPricingIndex({})
  }
}
